var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "#93A1BD",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00047 2.37254L5.84547 4.21754C6.13797 4.51004 6.61047 4.51004 6.90297 4.21754C7.19547 3.92504 7.19547 3.45254 6.90297 3.16004L4.52547 0.775039C4.23297 0.482539 3.76047 0.482539 3.46797 0.775039L1.09047 3.16004C0.797969 3.45254 0.797969 3.92504 1.09047 4.21754C1.38297 4.51004 1.85547 4.51004 2.14797 4.21754L4.00047 2.37254ZM4.00047 11.6275L2.15547 9.78254C1.86297 9.49004 1.39047 9.49004 1.09797 9.78254C0.805469 10.075 0.805469 10.5475 1.09797 10.84L3.47547 13.225C3.76797 13.5175 4.24047 13.5175 4.53297 13.225L6.91047 10.8475C7.20297 10.555 7.20297 10.0825 6.91047 9.79004C6.61797 9.49754 6.14547 9.49754 5.85297 9.79004L4.00047 11.6275Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.6e0ab66e.svg";
export { ForwardRef as ReactComponent };